import { Formatter } from 'gf-ui';
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';

const Select = ({ kid, item, domande, risposte_all, value, onChange }) => {
  const [visibile, mostra] = useState(false)
  const domanda = item.DESCRIZIONE;
  const mostraSe = item.ARR_RIFERIMENTI;
  const risposte = item.ARR_RISPOSTE;

  const selVal = (val) => {
    onChange(kid, val)
  }

  useEffect(() => {
    if (mostraSe.length === 0) {
      mostra(true);
    } else {
      let mostraDomanda = false;
      Object.keys(mostraSe).forEach(idx => {
        const domanda_rif = mostraSe[idx];
        if (risposte_all.indexOf(domanda_rif.ID_MA_CSS_D_R) >= 0) {
          mostraDomanda = true;
        }
      })
      mostra(mostraDomanda)
    }
  }, [domande, mostraSe, risposte_all])

  useEffect(() => {
    if (!visibile && !Formatter.isStringaVuota(value)) {
      onChange(kid, null)
    }
  }, [kid, onChange, value, visibile])

  return (
    <>
      {visibile && (
        <Form.Group className="mb-3 form-group">
          <div className="p-0 bg-white" style={{ border: `1px solid ${value ? 'green' : 'lightgrey'}`, borderRadius: '10px' }}>
            <div className={`form-control d-flex flex-row align-items-center justify-content-between w-100 ${(value !== undefined && value !== "") ? "is-valid" : ""}`} style={{ border: 'none', borderRadius: '10px' }}>
              <div className="form-label fw-bold" dangerouslySetInnerHTML={{ __html: domanda }} />
            </div>
            <div className='p-4'>
              <Form.Select as="select" aria-label={domanda} onChange={(e) => selVal(e.target.value)} value={value} required={item.FLG_OBBLIGATORIA === "-1"} className={(value !== undefined && value !== "") ? "border border-success" : ""}>
                <option value="">Seleziona ...</option>
                {Object.keys(risposte).map((risposta, index) =>
                  <option key={`select_${risposte[risposta].DESCRIZIONE}`} value={risposte[risposta].ID_MA_CSS_D_R}>{risposte[risposta].DESCRIZIONE}</option>
                )}
              </Form.Select>
            </div>
          </div>
        </Form.Group>
      )}
    </>
  )
}

export default Select;